export default __webpack_public_path__ + "static/media/1.ed841bb7.png";